import React from 'react';
import ReactDOM from "react-dom";
import styles from './styles.css';
import Arrow from '../icons/arrow';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Swipers } from '../swiper';

class _Carousel2 extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        };

    };

    componentDidUpdate(prevProps, prevState, snapshot){
        
    }

    render() {
        return (
            <div className={this.props.className} style={this.props.style ? this.props.style : {}}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }} />
                <Swipers
                    ref={node => (this.swiper = node)}
                    navigationIcon={<Arrow />}
                    navigationClass={this.props.navigationClass}
                    hideNavigation={this.props.hideNavigation}
                    slidesPerView={this.props.slidesPerView}
                    spaceBetween={this.props.spaceBetween}
                    slidesOffsetBefore={0}
                    getCarouselCurrentStep={this.props.getCarouselCurrentStep}
                    step={this.props.step}
                    getSlideChangeStep={this.props.getSlideChangeStep}
                    products={this.props.products}
                    >
                    {
                        this.props.children
                    }
                </Swipers>
            </div>
        );
    }
}

// const Carousel = _Carousel;
const Carousel = _Carousel2;

export {
    Carousel
}